export function StatCard({ icon: Icon, label, value, testid, sub }) {
  return (
    <div className="flex items-center gap-4 rounded-2xl border border-white/10 bg-[#282421] p-5" data-testid={testid}>
      <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-[#D4AF37]/10 text-[#D4AF37]">
        <Icon className="h-5 w-5" />
      </div>
      <div>
        <p className="text-2xl font-700 text-[#FDFBF7]">{value}</p>
        <p className="text-xs uppercase tracking-wide text-[#A8A29E]">{label}</p>
        {sub && <p className="text-xs text-[#A8A29E]/70">{sub}</p>}
      </div>
    </div>
  );
}

export function Card({ title, icon: Icon, action, children, testid, className = "" }) {
  return (
    <div className={`rounded-2xl border border-white/10 bg-[#282421] p-6 ${className}`} data-testid={testid}>
      {(title || action) && (
        <div className="mb-4 flex items-center justify-between gap-3">
          <div className="flex items-center gap-2 text-[#D4AF37]">
            {Icon && <Icon className="h-5 w-5" />}
            <h2 className="font-semibold text-[#FDFBF7]">{title}</h2>
          </div>
          {action}
        </div>
      )}
      {children}
    </div>
  );
}

export const btnPrimary =
  "flex items-center gap-1.5 rounded-lg bg-[#D4AF37] px-4 py-2.5 text-sm font-semibold text-[#1A1715] transition-colors hover:bg-[#E5C564] disabled:cursor-not-allowed disabled:opacity-40";
export const btnGhost =
  "flex items-center gap-1.5 rounded-lg border border-white/10 px-4 py-2.5 text-sm text-[#FDFBF7] transition-colors hover:border-[#D4AF37]/50 hover:text-[#D4AF37]";
export const inputCls =
  "h-11 w-full rounded-xl border border-white/10 bg-[#1A1715] px-4 text-sm text-[#FDFBF7] placeholder:text-[#A8A29E]/60 outline-none transition-colors focus:border-[#D4AF37] focus:ring-2 focus:ring-[#D4AF37]/30";

export function fmtDate(iso, withTime = true) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("nb-NO", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      timeZone: "Europe/Oslo",
      ...(withTime ? { hour: "2-digit", minute: "2-digit" } : {}),
    });
  } catch {
    return iso;
  }
}

export function fmtKr(n) {
  return `${Math.round(n || 0).toLocaleString("nb-NO")} kr`;
}

export function downloadBlob(data, filename) {
  const url = window.URL.createObjectURL(new Blob([data]));
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}
